<template>
  <div class="form-group row">
    <div class="col-sm-2 text-sm-right">
      <label>Numero Protocolo:</label>
    </div>
    <div class="col-md-3 col-sm-10 mb-3">
      <the-mask :mask="['##/######/####']" type="text" class="form-control" v-model="filtroProtocolo.numeroProcesso"/>
    </div>

    <div class="col-sm-2 text-sm-right">
      <label>Interessado:</label>
    </div>
    <div class="col-md-4 col-sm-10 mb-3">
      <input type="text" class="form-control" v-model="filtroProtocolo.interessado">
    </div>

    <div class="col-sm-2 text-sm-right">
      <label>Assunto:</label>
    </div>
    <div class="col-sm-9 mb-3">
      <input type="text" class="form-control" v-model="filtroProtocolo.assunto">
    </div>

    <div class="col-12 row btnAcoes">
      <div class="col-1"></div>
      <button class="btn btn-outline-success" @click.prevent="pesquisar()"> Pesquisar </button>
      <button class="btn btn-outline-danger" @click.prevent="limpar"> Limpar </button>
    </div>
  </div>
</template>

<script>
import VirtusService from '@/services/VirtusService'
import eventBus from '@/uteis/eventBus'

export default {
  name: 'filtroPesquisa',

  props: {
    rowsNumber: { required: true, type: Number },
    eventBusDataName: { required: true, type: String },
    eventBusPaginationName: { required: true, type: String }
  },

  data () {
    return {
      filtroProtocolo: {
        numeroProcesso: '',
        assunto: '',
        interessado: '',
        offset: 1,
        range: this.rowsNumber,
        idDepartamento: '',
        apensado: false
      }
    }
  },

  created () {
    eventBus.$on(this.eventBusPaginationName, (numeroPagina) => {
      this.trocaDePagina(numeroPagina)
    })

    this.service = new VirtusService()
    this.pesquisar()
  },

  methods: {
    pesquisar (page = 1) {
      const dadosSessao = this.$store.getters.getDadosSessao
      this.filtroProtocolo.idDepartamento = dadosSessao.sessao.idDepartamento
      this.filtroProtocolo.offset = page

      this.service.consultarProcessosElaboracao(this.filtroProtocolo).then(res => {
        eventBus.$emit(this.eventBusDataName, res)
      }).catch(err => {
        console.log(err)
      })
    },

    limpar () {
      this.filtroProtocolo.numeroProcesso = ''
      this.filtroProtocolo.assunto = ''
      this.filtroProtocolo.interessado = ''
      this.pesquisar()
    },

    trocaDePagina (numeroPagina) {
      this.pesquisar(numeroPagina)
    }
  },

  destroyed () {
    eventBus.$off(this.eventBusPaginationName)
  }
}
</script>

<style scoped lang="scss">

.row {
  margin-top: 2px;
}

</style>
